import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'FOREIGN_TRADE',
    icon: 'menu-foreign-trade',
    label: '外贸销售',
    children: [
      {
        code: 'FOREIGN_TRADE_SALES_CONTRACT',
        icon: 'menu-foreign-sales-contract',
        label: '外贸销售合同',
        path: '/foreign-trade/sales-contract',
      },
      {
        code: 'FOREIGN_TRADE_CONTRACT',
        icon: 'menu-foreign-purchase-contract',
        label: '外贸采购合同',
        path: '/foreign-trade/purchase-contract',
      },
      {
        code: 'FOREIGN_TRADE_PAYMENT',
        icon: 'menu-foreign-payment',
        label: '外贸付款',
        path: '/foreign-trade/payment',
      },
      {
        code: 'FOREIGN_TRADE_RECEIPT',
        icon: 'menu-foreign-receipt',
        label: '外贸回款',
        path: '/foreign-trade/receipt',
      },
      {
        code: 'FOREIGN_TRADE_PROFORMA_INVOICE',
        icon: 'menu-docx-templates',
        label: '形式发票',
        path: '/foreign-trade/proforma-invoice',
      },
      {
        code: 'FOREIGN_TRADE_QUOTE_CALCULATOR',
        icon: 'menu-default',
        label: '报价计算器',
        path: '/foreign-trade/quote-calculator',
      },
      {
        code: 'FOREIGN_TRADE_DEPOSIT_COLLECTION_PAYMENT',
        icon: 'menu-purchase-payment',
        label: '预收定金',
        path: '/foreign-trade/deposit-collection-payment',
      },
      {
        disabled: true,
        code: 'FOREIGN_TRADE_CRM',
        icon: 'menu-crm',
        label: 'CRM 管理',
        path: '/foreign-trade/crm',
      },
      {
        code: 'FOREIGN_TRADE_MY_CUSTOMER',
        icon: 'menu-contacts',
        label: '我的客户',
        path: '/foreign-trade/my-customer',
      },
    ],
  },
] satisfies Menu[];
